// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#dt2, #dt1 {\n  border: none;\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  height: 45px;\n  z-index: 11;\n  opacity: 0;\n  width: 100%;\n}\n\n#dt2:focus, #dt1:focus {\n  border: none;\n  outline: none;\n}\n\nion-checkbox::part(container) {\n  background: white;\n}\n\n.mat-mdc-select-panel {\n  padding: 0px !important;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
